/* eslint-disable no-shadow */
export const API_TIMEOUT = 10 * 1000;

export enum EnumLang {
  En = 'en',
  Zh = 'zh',
  ZhHK = 'zh-HK',
  Ar = 'ar',
}

export enum EnumErrorType {
  AjaxTimeout = '请求超时',
  AjaxNetworkError = '网络异常',
  AjaxCancel = '请求取消',
  AjaxDefault = '接口异常兜底',
  AjaxError = '接口异常',
  AjaxNotExist = '请求不存在',
  AjaxReject = '请求方法拒绝',
  AjaxServiceError = '服务异常',
  AjaxOffline = '网络连接中断',
  AjaxTokenTimeout = '登录校验异常',
  AjaxSaleForceTimeout = '后端请求 saleforce 超时',
  // pike 异常
  Pike = 'pike',
  // knb 异常
  Knb = 'knb',
  // 语法错误通用类
  Grammar = 'grammar',
  // vue 全局捕获错误
  GlobalError = 'global-error',
  // 业务通用类
  Business = 'business',
  // JSON.parse try-catch 异常捕获
  JsonParseError = 'json-parse',
  JsonStringfyError = 'json-stringfy',
}

/**
 * 导航栏三种类型
 */
export enum EnumNavType {
  // 默认样式
  Default = 'default',
  // 客服页排队
  KeFuLineUp = 'lineUp',
  // 客服聊天页
  KeFuHeader = 'KefuHeader',
}

/**
 * 首页页面类型
 */
export enum EnumPageType {
  Home = 'home',
  Order = 'order',
  Chat = 'chat',
  Question = 'question',
}

/**
 * 页面状态
 */
export enum EnumPageStatus {
  // 无数据
  Empty = 'empty',
  // 請求失敗，點擊加載重試
  Fail = 'fail',
  // 数据加载中
  Loading = 'loading',
  // 数据加载正常
  Normal = 'normal',
}

/**
 * Faq类型
 */
export enum EnumFaqType {
  // 服务进度
  Progress = 'apply_progress',
  // 问题分类
  CategoryFaq = 'category',
  // 订单问题
  Order = 'order',
}

/**
 * 点踩点赞类型
 */
export enum EnumEvaluationType {
  Unhelp = 'unhelpful',
  Help = 'helpful',
}

/**
 * 渠道类型
 */
export enum EnumChannelType {
  Online = 'online',
  Form = 'form',
}

/**
 * 渠道类型
 */
export enum EnumOrderType {
  Order = 'order',
  Rider = 'waimaiRider',
  WaiMaiShop = 'waimaiShop',
}
/*
 * 会话状态
 */
export enum EnumChatStatus {
  // 会话创建
  Initial = -1,
  // 无客服
  NoStaff,
  // 会话中
  Human,
  // 排队中
  Queue,
  // 会话已结束
  End,
  // 无效客户
  InvaliadCustomer,
}

/**
 * chat 消息类型
 */
export enum EnumMessageType {
  // 时间线消息
  Time = 'Time',
  // 文本消息
  ChatText = 'ChatText',
  // 图片消息
  Picture = 'Picture',
  // 结束会话
  ChatEnd = 'ChatEnd',
  // 邀评
  InviteEva = 'InviteEva',
  // 通知消息已读 ｜ 用户消息已读统计
  MsgRead = 'MsgRead',
  // 上行消息 - start
  // 评价
  Evaluation = 'Evaluation',
  // 用户进入/离开 chat 页面
  CustomerLoginStatus = 'CustomerLoginStatus',
  // 上行消息 - end
  // 命令式消息类型（无 UI） - 开始
  // 开始会话
  ChatBegin = 'ChatBegin',
  // 排队中
  ChatQueue = 'ChatQueue',
  // 取消排队
  QueueCancel = 'QueueCancel',
  // 排队消息变更
  QueueChange = 'QueueChange',
  // 离开 chat 页面
  UserLeavePage = 'UserLeavePage',
  // 会话转接
  ChatTransfer = 'ChatTransfer',
  // 命令式消息类型（无 UI） - 结束
}

export enum EnumLeaveType {
  Close = 'close',
  Welcome = 'welcome',
}

/**
 * chat 消息状态
 */
export enum EnumMessageStatus {
  Loading = 'loading',
  Success = 'success',
  Fail = 'fail',
}

/**
 * chat 消息位置
 */
export enum EnumMessagePosition {
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
}

/**
 * chat 消息发送类型
 */
export enum EnumSenderType {
  System = 'SYSTEM',
  Customer = 'CUSTOMER',
  Staff = 'STAFF',
}

/**
 * 消息样式类型
 * 由于用在 class 样式上，故 value 首字母小写
 */
export enum EnumMessageStyleType {
  // 默认样式
  Plain = 'plain',
  // 卡片样式
  Card = 'card',
  // 自定义样式
  Self = 'self',
  // 系統
  System = 'system',
}

/**
 * pike 连接状态
 */
export enum EnumPikeConnectStatus {
  Connected = 'connected',
  Disconnected = 'disconnected',
  Connecting = 'connecting',
}

export enum EnumEventHub {
  // 输入/聚焦等场景需要将消息容器滚动到底部
  ScrollToBottom = 'ScrollToBottom',
  // 异步消息导致容器高度改变，需要重制高度
  ResetScroll = 'ResetScroll',
}

/**
 * 图片上传状态
 */
export enum EnumImageUploadStatus {
  Loading = 'loading',
  Success = 'success',
  Fail = 'fail',
}

// 订单类型
export const OrderComponentMap = {
  [EnumOrderType.Order]: 'OrderItem',
  [EnumOrderType.Rider]: 'RiderItem',
  [EnumOrderType.WaiMaiShop]: 'WaiMaiShopItem',
};

/**
 * 创建会话场景
 */
export enum EnumChatScene {
  // 浮窗场景
  FloatWindow = 'FloatWindow',
  // FAQ 页面点击联络客服
  FAQ = 'FAQ',
  // 非叶子结点转人工
  FAQChat = 'FAQChat',
  // 服务进度页处理中会话点击进入
  ServiceProgress = 'ServiceProgress',
  // 会话页面点击重新联络客服
  ChatAgain = 'ChatAgain',
  // 服务进度直接转人工
  ServiceProgressIntoChat = 'ServiceProgressIntoChat',
}

/**
 * 灵犀埋点 position_name 枚举
 */
export enum EnumLxPositionName {
  PreSuggest = '预判推荐区',
  OrderCard = '订单卡片区',
  Answer = '答案区',
  ForwardHuman = '转人工区',
  Case = '工单区',
  Feature = '功能区',
}

export enum EnumChatCaseStatus {
  // chat工单/离线工单 等待客服处理
  Pending = '1',
  // chat工单/离线工单 已结案待评价
  ToRate = '2',
  // chat工单/离线工单 已结案
  CaseEnd = '3',
  // chat工单 客服已回复
  Processing = '4',
  // chat工单 会话已结束，工单未结案
  ChatEnd = '5',
}

export enum EnumCaseType {
  Chat = 'chat',
  Case = 'case',
}

// eslint-disable-next-line no-shadow
export enum EnumButtonType {
  // 未结束会话，直接进入会话
  Chat = 1,
  // 已结束会话，进入重新联络客服
  ChatReconnect,
  // 已结束会话，查看历史消息
  ChatHistory,
  // chat/form 已结案去评价
  Rate,
  // form 未结案查看表单内容
  Form,
}

export enum EnumStatusMap {
  Delivery = '配送中',
  Placed = '已下单',
  Cancel = '已取消',
}

export enum EnumAnswerType {
  Text = 0,
  Form = 1,
}

export enum EnumUserType {
  User = 'user',
  Merchant = 'merchant',
  Rider = 'rider',
}

export enum EnumButtonShowType {
  Default = 0,
  Primary = 1,
}

export const LX_EMPTY_VALUE = -999;

/*
  服务大厅-订单助手-埋点映射关系
  其中 1，2 枚举值分别代表『服务门户首页』与『订单常见问题页』
*/
export const OrderHelperBidMcType = {
  // 服务门户首页-订单助手-mc事件bid
  1: 'b_oversea_helpcenter_zj02ho01_mc',
  // 订单常见问题页-订单助手-mc事件bid
  2: 'b_oversea_helpcenter_peefojyo_mc',
};

export const OrderHelperBidMvType = {
  // 服务门户首页-订单助手-mv事件bid
  1: 'b_oversea_helpcenter_zj02ho01_mv',
  // 订单常见问题页-订单助手-mv事件bid
  2: 'b_oversea_helpcenter_peefojyo_mv',
};

// 工单状态
export enum EnumCaseStatus {
  InProgress = 1, // 进行中
  BeEvaluated = 2, // 待评价
  Deprecated = 3, // 已废弃
  Closed = 4, // 已结案
  Unknown = 999, // 未知
}
// 商家大学相关映射-线下环境
const TEST_COLLEGE = {
  en: 'testkeeta',
  zh: 'hkkeeta',
  'zh-HK': 'hkkeeta',
  default: 'testkeeta',
};

// 商家大学相关映射-线上环境
const PROD_COLLEGE = {
  en: 'keetaenhk',
  zh: 'keetazhhk',
  'zh-HK': 'keetazhhk',
  default: 'keetaenhk',
};

// 美团大学，海外学院，英文、繁体学院
export const PEIXUN_COLLEGE = {
  test: TEST_COLLEGE,
  st: PROD_COLLEGE,
  prod: PROD_COLLEGE,
  default: PROD_COLLEGE,
};

// 时间格式配置
export const DATE_TIME_PATTERN = {
  en: 'd MMM yyyy HH:mm:ss',
  ar: 'dd/MM/yyyy h:mm:ss a',
  'zh-hk': 'yyyy年M月d日 HH:mm:ss',
  default: 'yyyy-MM-dd HH:mm:ss',
};

export enum EnumBizLine {
  KEETA = 'kfood',
  KEEMART = 'keemart',
}
